import * as React from "react";
import {RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import Okyc from "myshubhlife-component/Okyc";
import {kycCompleted} from "Kyc/action";
import {EventName} from "documents/event";

interface IConnectProps {
    dispatch?: (action: any) => void;
}

const CURRENT_ADDRESS_PROOF = "Current Address Proof";
const AadhaarOkyc = (props: IConnectProps & RouteComponentProps) => {
    const handleSubmit = (status: boolean) => {
        if (status) {
            props.dispatch(kycCompleted(status));
        }
    };
    return <Okyc kycStatus={handleSubmit}/>;
};

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {};
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(AadhaarOkyc);
